<template>
<div class="wel-con" :class="FullScreen?'map-FullScreen':'map'">
  <!-- 按钮 -->
    <div class="Full" @click="buttoncli">
      <i class="el-icon-rank" style="height:40px;"></i>
    </div>
    <!-- <dv-full-screen-container>content</dv-full-screen-container> -->
     <!-- 头部 -->
    <div class="head-title">
      <dv-decoration-8 style="width:25%;;height:60px;" />
      <div class="title-con">
        <div class="bigtitle">
          <span>专利监控平台</span>
        </div>
        <dv-decoration-5 style="width:100%;height:60px;" />
      </div>
      <dv-decoration-8 :reverse="true" style="width:25%;height:60px;" />
    </div>
    <!-- 中间主体内容 -->
    <div class="smcon" v-if="showSwipe">
      <dv-border-box-1>
        <div class="border-con">
           <div class="border-smcon">
            <!-- 时间 -->
            <div class="time">{{nowTime}}</div>
            <!-- 装饰 -->
            <div class="Decoration">
              <dv-decoration-3 style="width:250px;height:30px;" />
            </div>

            <div class="con-left">
              <dv-border-box-13>
                <div class="left-bp">
                  <div class="left-item">
                    <div class="po-ab">专利类型统计</div>
                    <div class="po-n">
                      <dv-charts :option="patentTypeTotal" style="width:100%;height:100%" />
                    </div>
                  </div>
                  <dv-decoration-10 style="width:100%;height:5px;" />
                  <div class="left-item pad-b">
                    <div class="po-ab pad-b">近5年申请量</div>
                    <div class="po-n">
                      <dv-charts :option="applyPatentForFive" style="width:100%;height:100%" />
                    </div>
                  </div>
                  <dv-decoration-4 :reverse="true" style="width:100%;height:5px;" />
                  <div class="left-item">
                    <div class="po-ab pad-b">专利类型占比</div>
                    <div class="po-n">
                      <dv-charts :option="proportionOfpatent" style="width:100%;height:100%" />
                    </div>
                  </div>
                </div>
              </dv-border-box-13>
            </div>

            <div class="con-cen">
              <div class="cen-box">
                <div class="cen-top">
                  <div class="cent-box">
                    <!-- <dv-border-box-7> -->
                    <div class="dv-smbox">
                      <div class="cent">
                        <dv-border-box-8>
                          <div class="title-box">
                            <div class="tbox-top">
                              <!-- 装饰 -->
                              <div class="zs-box">
                                <dv-decoration-1 style="width:100%;height:100%" />
                              </div>
                              <div class="cen-t-content1" style="text-align: center;">2800</div>
                              <div class="cen-t" style="text-align: center;">专利总量</div>

                              <div style="display: flex;margin-top: 30px;">
                                <div>
                                  <div class="cen-t-content2">1500</div>
                                  <div class="cen-t">有效专利</div>
                                </div>
                                <div style="margin-left: auto;margin-right:auto;">
                                  <div class="cen-t-content2">1500</div>
                                  <div class="cen-t">审中专利</div>
                                </div>
                                <div>
                                  <div class="cen-t-content2">1500</div>
                                  <div class="cen-t">无效专利</div>
                                </div>
                              </div>

                              <div style="display: flex;margin-top: 30px;">
                                <div>
                                  <div class="cen-t-content3">1500</div>
                                  <div class="cen-t">有效发明</div>
                                </div>
                                <div style="margin-left: auto;margin-right:auto;">
                                  <div class="cen-t-content3">1500</div>
                                  <div class="cen-t">有效新型</div>
                                </div>
                                <div>
                                  <div class="cen-t-content3">1500</div>
                                  <div class="cen-t">有效外观</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </dv-border-box-8>
                      </div>
                      <div class="cent">
                        <dv-charts :option="machineTpyeoption" />
                      </div>
                    </div>
                    <!-- </dv-border-box-7> -->
                  </div>
                </div>

                <div class="cen-bottom">
                  <dv-border-box-12>
                    <div class="tab-box">
                      <div class="tab-item">
                        <div class="po-tab">申请人排行</div>
                        <div class="po-tn">
                          <dv-scroll-board :config="applicantConfig" style="width:100%;height:100%" />
                        </div>
                      </div>
                      <dv-decoration-2 :reverse="true" style="width:5px;height:100%;" />
                      <div class="tab-item">
                        <div class="po-tab">发明人排行</div>
                        <div class="po-tn">
                          <dv-scroll-board :config="inventorConfig" style="width:100%;height:100%" />
                        </div>
                      </div>
                      <dv-decoration-2 :reverse="true" style="width:5px;height:100%;" />
                      <div class="tab-item">
                        <div class="po-tab">代理机构排行</div>
                        <div class="po-tn">
                          <dv-scroll-board :config="agencyConfig" style="width:100%;height:100%" />
                        </div>
                      </div>
                    </div>
                  </dv-border-box-12>
                </div>

              </div>
            </div>

            <div class="con-right">
              <dv-border-box-13>
                <div class="left-bp">
                  <div class="left-item">
                    <div class="po-ab">最新公开</div>
                    <div class="po-n scroll-view-block">
                        <dv-scroll-board :config="newPubilcPatent" style="width:100%;height:100%" @click="pubPatInfo"/>
                    </div>
                  </div>
                  <dv-decoration-10 class="rotate" style="width:100%;height:5px;" />
                  <div class="left-item pad-b">
                    <div class="po-ab pad-b">最新申请</div>
                    <div class="po-n">
                      <dv-scroll-board :config="applyPatentConfig" style="width:100%;height:100%" />
                    </div>
                  </div>
                  <dv-decoration-4 class="rotate" :reverse="true" style="width:100%;height:5px;" />
                  <div class="left-item">
                    <div class="po-ab pad-b">近期待缴</div>
                    <div class="po-n po-bn">
                      <dv-scroll-board :config="patentFee" style="width:100%;height:100%" />
                    </div>
                  </div>
                </div>
              </dv-border-box-13>
            </div>

           </div>
        </div>
      </dv-border-box-1>
    </div>

</div>
</template>
 
<script>
import editor from '../components/kindeditor.vue'
// 导入全屏显示方法
import { fullscreenToggel } from "@/utils/util";
 
export default {
  name: 'app',
  components: {
    editor
  },
  data () {
    return {
      FullScreen: false,
      showSwipe: false,
      nowTime: '',
      // 专利类型统计
      patentTypeTotal: {
        grid: {
          left: 40,
          right: 10,
          top: 20,
          bottom: 30,
          style: {
            fill: "rgba(0, 0, 0, 0)"
          }
        },
        xAxis: {
          data: ["发明专利", "实用新型", "外观设计"],
          axisLine: {
            style: {
              stroke: "#fff",
              lineWidth: 1
            }
          },
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 12,
              rotate: 0
            }
          }
        },
        yAxis: {
          data: "value",
          axisLine: {
            style: {
              stroke: "#fff",
              lineWidth: 1
            }
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 12,
              rotate: 1
            }
          }
        },
        series: [
          {
            data: [1800, 1200, 556],
            type: 'bar',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)'
            },
            label: {
              show: true
            }
          }
        ]
        },
      // 近5年申请量
      applyPatentForFive: {
        legend: {
          top: 20,
          iconHeight: 12,
          data: ["总量","发明", "新型", "外观"],
          textStyle: {
            fontSize: 12,
            fill: "#fff",
          }
        },
        grid: {
          left: 40,
          right: 10,
          top: 20,
          bottom: 30,
          style: {
            fill: "rgba(0, 0, 0, 0)"
          },
          containLabel: true
        },
        xAxis: {
          data: ["2018", "2019", "2020", "2021", "2022"],
          type: 'category',
          axisLine: {
            style: {
              stroke: "#fff",
              lineWidth: 1
            }
          },
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 12,
              rotate: 0
            }
          }
        },
        yAxis: {
          data: "value",
          axisLine: {
            style: {
              stroke: "#fff",
              lineWidth: 1
            }
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 12,
              rotate: 0
            }
          }
        },
        series: [
          {
            name: '总量',
            data: [1900, 2130, 2140, 2650, 3658],
            type: "line",
            lineArea: {
              show: true,
              gradient: ["rgba(55, 162, 218, 0.6)", "rgba(55, 162, 218, 0)"]
            },
            label: {
              show: true
            }
          },
          {
            name: '发明',
            data: [500, 580, 690, 700, 1008],
            type: "line",
            lineArea: {
              show: true,
              gradient: ["rgba(55, 162, 218, 0.6)", "rgba(55, 162, 218, 0)"]
            },
            label: {
              show: true
            }
          },
          {
            name: '新型',
            data: [600, 650, 950, 750, 1200],
            type: "line",
            lineArea: {
              show: true,
              gradient: ["rgba(55, 162, 218, 0.6)", "rgba(55, 162, 218, 0)"]
            },
            label: {
              show: true
            }
          },
          {
            name: '外观',
            data: [800, 900, 500, 1200, 1450],
            type: "line",
            lineArea: {
              show: true,
              gradient: ["rgba(55, 162, 218, 0.6)", "rgba(55, 162, 218, 0)"]
            },
            label: {
              show: true
            }
          }
        ]
      },
      // 专利占比
      proportionOfpatent: {
        grid: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 10,
          style: {
            fill: "rgba(0, 0, 0, 0)"
          }
        },
        series: [
          {
            type: "pie",
            radius: "80%",
            data: [
              { name: "发明专利", value: 93 },
              { name: "实用新型", value: 32 },
              { name: "外观设计", value: 65 }
            ],
            insideLabel: {
              show: true
            },
            roseType: true
          }
        ]
      },
      // 今年和去年申请量对比
      machineTpyeoption: {
        legend: {
          bottom: 10,
          iconHeight: 12,
          data: ["今年申请量", "去年申请量"],
          textStyle: {
            fontSize: 12,
            fill: "#fff"
          }
        },

        radar: {
          indicator: [
            { name: "1月", max: 100 },
            { name: "2月", max: 100 },
            { name: "3月", max: 100 },
            { name: "4月", max: 100 },
            { name: "5月", max: 100 },
            { name: "6月", max: 100 },
            { name: "7月", max: 100 },
            { name: "8月", max: 100 },
            { name: "9月", max: 100 },
            { name: "10月", max: 100 },
            { name: "11月", max: 100 },
            { name: "12月", max: 100 }
          ],
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 12
            }
          },
          polygon: true,
          axisLine: {
            style: {
              stroke: "rgba(251, 114, 147, .3)"
            }
          },
          splitLine: {
            style: {
              stroke: "rgba(251, 114, 147, .5)",
              fill: "rgba(251, 114, 147, .2)"
            }
          }
        },
        series: [
          {
            name: "今年申请量",
            type: "radar",
            data: [15, 20, 25, 30, 35, 40],
            label: {
              show: true
            },
            animationCurve: "easeOutBounce"
          },
          {
            name: "去年申请量",
            type: "radar",
            data: [
              8,
              16,
              24,
              32,
              25,
              42,
              13,
              34,
              13,
              20,
              14,
              32
            ],
            label: {
              show: true
            },
            animationCurve: "easeOutBounce"
          }
        ]
      },
      // 申请人排行
      applicantConfig: {
        data: [
          ["西南石油大学", "11234件"],
          ["西南交通大学", "12222件"],
          ["中兴通讯股份有限公司", "11234件"],
          ["重庆医科大学", "11222件"],
          ["三星移动显示器株式会社", "11123件"],
          ["ETC外延技术中心有限公司", "10234件"],
          ["四川大学", "10123件"],
          ["艾尼纳制药公司", "10111件"],
          ["富士通日立等离子显示器股份有限公司", "9123件"],
          ["深圳市亚略特生物识别科技有限公司", "9111件"]
        ],
        index: true,
        columnWidth: [50],
        align: ["center"]
      },
      // 发明人排行
      inventorConfig: {
        data: [
          ["金沈蓉", "12306件"],
          ["刘建强", "12304件"],
          ["罗江水", "12302件"],
          ["李玉斧", "12301件"],
          ["余福", "12202件"],
          ["洪洗象", "12202件"],
          ["方寒", "12201件"],
          ["萧炎", "12200件"],
          ["堕姬", "12001件"],
          ["伍六七", "11999件"]
        ]
      },
      // 代理机构排行
      agencyConfig: {
        data: [
          ["其知创新专利代理事务所（普通合伙）", "1251件"],
          ["深圳市永杰专利商标事务所", "1222件"],
          ["太原市科瑞达专利代理有限公司", "1118件"],
          ["郑州红元帅专利代理事务所", "800件"],
          ["北京理工大学专利中心", "565件"],
          ["上海新天专利代理有限公司", "524件"],
          ["沈阳科苑专利商标代理有限公司", "234件"],
          ["复旦大学专利事务所", "225件"]
        ]
      },
      // 最新公开
      newPubilcPatent: {
        header: ['专利名称','申请人','发明人','公开日'],
        data: [
                ["一种处理SCADA系统数据的实时小波阈值去噪方法", "西南石油大学","李长俊,仇柏林,贾文龙","2022-04-08"],
                ["一种套管卡瓦配套装置及其使用方法","西南石油大学","杨国龙,王浩宇,黄曾","2022-04-08"],
                [" 基于多传感器融合技术的四氢噻吩浓度的在线检测方法及系统","西南石油大学"," 葛亮,马乐,胡泽","2022-04-08"],
                [" 基于多传感器融合技术的四氢噻吩浓度的在线检测方法及系统","西南石油大学"," 葛亮,马乐,胡泽","2022-04-08"],
                [" 基于多传感器融合技术的四氢噻吩浓度的在线检测方法及系统","西南石油大学"," 葛亮,马乐,胡泽","2022-04-08"],
                [" 基于多传感器融合技术的四氢噻吩浓度的在线检测方法及系统","西南石油大学"," 葛亮,马乐,胡泽","2022-04-08"],
                [" 基于多传感器融合技术的四氢噻吩浓度的在线检测方法及系统","西南石油大学"," 葛亮,马乐,胡泽","2022-04-08"],
                [" 基于多传感器融合技术的四氢噻吩浓度的在线检测方法及系统","西南石油大学"," 葛亮,马乐,胡泽","2022-04-08"],
                [" 基于多传感器融合技术的四氢噻吩浓度的在线检测方法及系统","西南石油大学"," 葛亮,马乐,胡泽","2022-04-08"],
                [" 基于多传感器融合技术的四氢噻吩浓度的在线检测方法及系统","西南石油大学"," 葛亮,马乐,胡泽","2022-04-08"],
                [" 基于多传感器融合技术的四氢噻吩浓度的在线检测方法及系统","西南石油大学"," 葛亮,马乐,胡泽","2022-04-08"],
                [" 基于多传感器融合技术的四氢噻吩浓度的在线检测方法及系统","西南石油大学"," 葛亮,马乐,胡泽","2022-04-08"],
              ],
              index: true,
              columnWidth: [50],
              align: ["center"],
              headerBGC: '',
              indexHeader: '序号',
              hoverPause: true
      },
      // 最新申请
      applyPatentConfig: {
        data: [
          ["西南石油大学", "11234件"],
          ["西南交通大学", "12222件"],
          ["中兴通讯股份有限公司", "11234件"],
          ["重庆医科大学", "11222件"],
          ["三星移动显示器株式会社", "11123件"],
          ["ETC外延技术中心有限公司", "10234件"],
          ["四川大学", "10123件"],
          ["艾尼纳制药公司", "10111件"],
          ["富士通日立等离子显示器股份有限公司", "9123件"],
          ["深圳市亚略特生物识别科技有限公司", "9111件"]
        ],
        index: true,
        columnWidth: [50],
        align: ["center"]
      },
      // 近期待缴
      patentFee: {
        header: ['专利名称','缴费类目','缴费金额','截止日期'],
        data: [
                ["一种稠油热采井固井用高温强度稳定剂", "第6年年费","180","2022-04-13"],
                ["书桌","年费滞纳金","150","2022-04-06"],
                ["餐边柜（2）","年费滞纳金"," 150","2022-04-06"],
                ["一种煤矿开采用钻孔装置","第2年年费","90","2022-04-06"],
                ["一种用于煤矿掘进机上的除尘装置","第2年年费","90","2022-04-06"],
                ["一种改进的注水井井口保温装置","第3年年费","90","2022-04-06"],
                ["一种可调节高度的蒸发皿三脚架","第3年年费","90","2022-04-06"],
                ["一种用于电线加工的切割装置","年费滞纳金","90","2022-04-06"],
                ["TBM隧道掘进机管片扶正方法","第4年年费","180","2022-04-13"],
                ["一种加压取心系统及方法","年费滞纳金","90","2022-04-02"]
              ],
              index: true,
              columnWidth: [50],
              align: ["center"],
              headerBGC: '',
              indexHeader: '序号'
      },
    }
  },
  created() {
  // 时间定时器
    setInterval(this.getTime, 1000);
    // 请求数据
    this.showSwipe = false;
    this.$nextTick(function() {
      this.showSwipe = true;
    });
  },
// 挂载结束状态(里面是操作)
  mounted() {},
    methods: {
      buttoncli() {
        // 是否全屏
        this.FullScreen = !this.FullScreen;
        fullscreenToggel();
      },
      // 当前时间
    getTime() {
      let now = new Date();
      let year = now.getYear();
      year = now.getFullYear();
      let month = now.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let days = now.getDate();
      days = days < 10 ? "0" + days : days;
      let hour = now.getHours();
      hour = hour < 10 ? "0" + hour : hour;
      let minutes = now.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      let seconds = now.getSeconds();
      seconds = seconds < 10 ? "0" + seconds : seconds;
      this.nowTime =
        year +
        "-" +
        month +
        "-" +
        days +
        "  " +
        hour +
        ":" +
        minutes +
        ":" +
        seconds;
    },
    // 查看最新公开专利详情
    pubPatInfo(data){
        console.log(data)
    }
  }
}
</script>
<style>
.wel-con {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-image: url("../assets/img/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.Full {
  width: 30px;
  /* width: 20px; */
  height: 30px;
  /* height: 20px; */
  position: absolute;
  /* top: 20px; */
  top: 10px;
  right: 10px;
  /* right: 15px; */
  z-index: 1000;
  box-sizing: border-box;
  padding: 5px;
  border-radius: 5px;
}
.Full:hover {
  background-color: #fff;
}
.Full > img {
  width: 100%;
  height: 100%;
}
.map {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}
.map-FullScreen {
  z-index: 9000;
  object-fit: contain;
  position: fixed !important;
  top: 0px !important;
  right: 0px !important;
  bottom: 0px !important;
  left: 0px !important;
  box-sizing: border-box !important;
  min-width: 0px !important;
  max-width: none !important;
  min-height: 0px !important;
  max-height: none !important;
  width: 100% !important;
  height: 100% !important;
  transform: none !important;
  margin: 0px !important;
}
.head-title {
  width: 100%;
  height: 100px;
  text-align: center;
  display: flex;
  justify-content: space-between;
}
.title-con {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.bigtitle {
  display: inline-block;
  font-size: 30px;
  color: #f9fbff;
  position: relative;
  height: 30px;
}
.bigtitle > span {
  width: 100%;
  text-align: center;
  position: absolute;
  left: 0px;
  top: 10px;
}
.smcon {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding-top: 100px;
}
.border-con {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
}
.border-smcon {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
}
.con-left {
  width: 25%;
  height: 100%;
  box-sizing: border-box;
  position: absolute;
  left: 0px;
  top: 0px;
}
.con-cen {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0px 25%;
}
.con-right {
  width: 25%;
  height: 100%;
  box-sizing: border-box;
  position: absolute;
  right: 0px;
  top: 0px;
}
.left-bp {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
}
.left-top {
  width: 100%;
  height: 49%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.left-bottom {
  width: 100%;
  height: 49%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cen-box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
}
.cen-top {
  width: 100%;
  height: calc(100% - 40%);
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.cent-box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 5px;
}
.cen-bottom {
  width: 100%;
  height: 40%;
  box-sizing: border-box;
}
.tab-box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  justify-content: center;
}
.left-item {
  width: 100%;
  height: 33%;
  box-sizing: border-box;
  position: relative;
}
.po-ab {
  position: absolute;
  top: 0px;
  left: 0px;
  color: #f9fbff;
}
.po-n {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 20px;
}
.tab-item {
  width: 33%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
}
.rotate {
  transform: rotate(180deg);
}
.po-tab {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  text-align: center;
  color: #f9fbff;
}
.po-tn {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 30px;
}
.pad-b {
  padding-top: 8px;
}
.po-bn {
  padding-top: 38px;
}
.cen-t {
  font-size: 18px;
  color: #f9fbff;
}
.cen-t-content1 {
  font-size: 36px;
  color: #3de7c9;
  font-weight: 200%;
}
.cen-t-content2 {
  font-size: 32px;
  color: #3de7c9;
  font-weight: 200%;
}
.cen-t-content3 {
  font-size: 30px;
  color: #3de7c9;
  font-weight: 200%;
}
.cen-b {
  display: flex;
  font-size: 18px;
  color: #3de7c9;
  margin-left: auto;
  margin-right: auto;
}
.cent {
  width: 50%;
  box-sizing: border-box;
  text-align: center;
}

.dv-smbox {
  width: 100%;
  height: 100%;
  /* padding: 10px; */
  box-sizing: border-box;
  display: flex;
  justify-items: space-between;
}
.title-box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
}
.time {
  position: absolute;
  top: -35px;
  right: 5%;
  font-size: 25px;
  color: #f9fbff;
}
.Decoration {
  position: absolute;
  top: -35px;
  left: 5%;
}
.tbox-top {
  width: 100%;
  height: 130px;
  box-sizing: border-box;
  position: relative;
}
.tbox-bottom {
  width: 100%;
  height: calc(100% - 130px);
  box-sizing: border-box;
}
.zs-box {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 180px;
  height: 50px;
}
.Coupons {
  widows: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.Half {
  width: 50%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/video.vue